import unidadenegocio from './unidadenegocio'
import fornecedor from './fornecedor'
import associado from './associado'
import lancamentoFaturamento from './lancamentoFaturamento'

export default {
  unidadenegocio,
  associado,
  fornecedor,
  lancamentoFaturamento,
}
